'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.processAccessRequest', [])

.factory('processAccessRequestService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/API/UserRequest';

    // **** HttpGet

    service.getInfosToProcess = function (userAccessRequestId, custodian) {
        var custodianUrlReq = ''
        if (!_.isUndefined(custodian) && !_.isEmpty(custodian)) custodianUrlReq = '_' + custodian;

        var url = baseUrl + '/Process/GetInfosToProcess' + custodianUrlReq + '/' + userAccessRequestId;

        return $http.get(url)
                    .then(function (response) {
                        var infos = response.data;
                        if (_.isUndefined(infos.UserAccessRequest)) {
                            return infos
                        }

                        if (!_.isUndefined(infos.UserAccessRequest.NewEmployeeSupervisor)) {
                            infos.NewEmployeeSupervisor = infos.UserAccessRequest.NewEmployeeSupervisor;
                        }

                        // Workaround: Merge IsPaused fields from UserAccessRequest.SystemRolePendings into Cards
                        // The Cards DTO doesn't include these fields, but the full data does
                        if (infos.Cards && infos.UserAccessRequest.SystemRolePendings) {
                            var pendingsByID = _.indexBy(infos.UserAccessRequest.SystemRolePendings, 'UserAccessRequest_SystemRolePendingID');

                            _.forEach(infos.Cards, function(card) {
                                if (card.UserAccessRequestSystem && card.UserAccessRequestSystem.SystemRolePendings) {
                                    _.forEach(card.UserAccessRequestSystem.SystemRolePendings, function(rolePending) {
                                        var fullData = pendingsByID[rolePending.UserAccessRequest_SystemRolePendingID];
                                        if (fullData) {
                                            rolePending.IsPaused = fullData.IsPaused;
                                            rolePending.PausedTimestamp = fullData.PausedTimestamp;
                                        }
                                    });
                                }
                            });
                        }

                        return infos;
                    });
    }

    service.getGroupsOfCards = function (cards, nbCardsByGroup) {
        var groups = [];

        var idxCard = 0;
        var group = [];

        _.forEach(cards, function(card) {
            if ((idxCard % nbCardsByGroup) == 0)
            {
                group = [];
                groups.push(group);
            }

            group.push(card);

            idxCard += 1;
        });

        return groups;
    }


    service.cancel = function (userAccessRequestId) {
        return $http.post(baseUrl + '/' + userAccessRequestId + '/Cancel', {});
    }

    // Custodian Number of Employees Pending
    service.getNumberOfEmployeesWithPendingsByCustodian = function () {
        var resUrl = baseUrl + '/Process/NumberOfEmployeesWithPending/ByCustodian/';
        return $http.get(resUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.updateAdminTicketNumber = function (userAccessRequestId, adminTicketNumber) {
        return $http.post(baseUrl + '/Process/UpdateAdminTicketNumber',
                          {
                              UserAccessRequestID: userAccessRequestId,
                              AdminTicketNumber: adminTicketNumber
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.checkAvailabilityForSystemAccount = function (systemId, username) {
        return $http.post(baseUrl + '/Process/CheckAvailabilityForSystemAccount',
                          {
                              SystemID: systemId,
                              Username: username
                          })
                    .then(function (response) {
                        if (response.data === 'true') return true;
                        return false;
                    });
    }

    service.createSystemAccount = function (eventID, userAccessRequestID, rolePendingID, resourcePendingID, employeeID, systemID, username) {
        return $http.post(baseUrl + '/Process/CreateSystemAccount',
                          {
                              eventID: eventID,
                              userAccessRequestID: userAccessRequestID,
                              rolePendingID: rolePendingID,
                              resourcePendingID: resourcePendingID,
                              employeeID: employeeID,
                              systemID: systemID,
                              username: username
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.removeSystemAccount = function (eventID, userAccessRequestID, rolePendingID, resourcePendingID, employeeID, systemID) {
        return $http.post(baseUrl + '/Process/RemoveSystemAccount',
                          {
                              eventID: eventID,
                              userAccessRequestID: userAccessRequestID,
                              rolePendingID: rolePendingID,
                              resourcePendingID: resourcePendingID,
                              employeeID: employeeID,
                              systemID: systemID
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.confirmManualStep = function (eventID, userAccessRequestID, rolePendingID, resourcePendingID, systemID) {
        return $http.post(baseUrl + '/Process/ConfirmManualStep',
                          {
                              eventID: eventID,
                              userAccessRequestID: userAccessRequestID,
                              rolePendingID: rolePendingID,
                              resourcePendingID: resourcePendingID,
                              systemID: systemID
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
